var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 21C41 18.3736 40.4827 15.7728 39.4776 13.3463C38.4725 10.9198 36.9993 8.71503 35.1421 6.85786C33.285 5.00069 31.0802 3.5275 28.6537 2.5224C26.2272 1.51731 23.6264 0.999995 21 0.999994C18.3736 0.999994 15.7729 1.51731 13.3463 2.5224C10.9198 3.52749 8.71505 5.00069 6.85787 6.85786C5.0007 8.71503 3.52751 10.9198 2.52242 13.3463C1.51732 15.7728 1.00001 18.3736 1.00001 21C1.00001 26.3043 3.10714 31.3914 6.85787 35.1421C10.6086 38.8929 15.6957 41 21 41C26.3043 41 31.3914 38.8929 35.1421 35.1421C38.8929 31.3914 41 26.3043 41 21Z",
    fill: "#F13C3C",
    stroke: "#F13C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9785 12L20.9785 20.9216",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9785 29.8359L21.0026 29.8359",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFilled);
export default __webpack_public_path__ + "static/media/error-filled.1c7044916e563b4bd1ab72dafad25da1.svg";
export { ForwardRef as ReactComponent };